export default __webpack_public_path__ + "static/media/RoundGradDelivering.70e66ad2.svg";